import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'

const SafeSegment = Segment as unknown as ComponentType<any>

/**
 * Provides a component that renders the encounter reviewer
 * @param review Encounter review entity
 * @param mode Render mode. Default: left
 */

type Props = {
  mode: string | undefined
  review: any
}

function EncounterReviewer(
  props: Props
): JSX.Element | null {
  const {
    mode = 'left',
    review
  } = props

  if (mode !== 'left') return null

  const name = review && review.reviewer && review.reviewer.userId
    ? `${review.reviewer.firstName} ${review.reviewer.lastName}`
    : <span className="italic">CDI Review Bypassed</span>

  return (
    <SafeSegment
      attached
      compact
      className="left-segment"
    >
      <div className="left-title">
        Reviewed By:
      </div>
      <div className="left-content">
        { name }
      </div>
    </SafeSegment>
  )
}

export default EncounterReviewer
